import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RadiusAuthenticationComponent} from './radius-authentication.component';
import {ArmFormModule} from '../../../components/arm-form/arm-form.module';
import {ArmFormTitleModule} from '../../../components/arm-form/arm-form-title/arm-form-title.module';
import {MaterialModule} from '../../../material.module';
import {FormsModule} from '@angular/forms';
import {InfraModule} from 'ac-infra';



@NgModule({
  declarations: [RadiusAuthenticationComponent],
  imports: [
    CommonModule,
    ArmFormModule,
    ArmFormTitleModule,
    MaterialModule,
    FormsModule,
    InfraModule
  ]
})
export class RadiusAuthenticationModule { }
